import React from 'react';
import { Input } from '@/components/ui/input';
import { fetchManufacturingProducts } from '@/lib/api/manufacturing';

export function CostSheetSourcePicker({ family, excludeId, value, onSelect, disabled }) {
  const [search, setSearch] = React.useState('');
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  const familyCode = String(family || '').trim();
  const familyRows = rows.filter((item) => familyCode && String(item.cod_fam || '').trim() === familyCode && item.id !== excludeId);
  React.useEffect(() => {
    let active = true;
    setRows([]); setError(''); setLoading(Boolean(family));
    const timer = setTimeout(async () => {
      if (!family) return;
      const result = await fetchManufacturingProducts({ codFam: family, searchTerm: search, status: 'all', limit: 80 });
      if (!active) return;
      setRows((result.data || []).filter((item) => item.id !== excludeId));
      setError(result.error ? 'No se pudieron cargar los artículos. Vuelve a buscar.' : '');
      setLoading(false);
    }, 250);
    return () => { active = false; clearTimeout(timer); };
  }, [family, excludeId, search]);
  return <div className="space-y-3">
    {familyCode && <p className="text-sm text-gray-600">Solo artículos de la familia <b>{familyCode}</b>.</p>}
    <Input aria-label="Buscar artículo origen" placeholder="Buscar por código o descripción" value={search} disabled={disabled} onChange={(event) => setSearch(event.target.value)} />
    {!family && <p>El artículo debe tener una familia asignada.</p>}
    {loading ? <p role="status">Buscando…</p> : error ? <p role="alert">{error}</p> : family && !familyRows.length ? <p>No hay artículos de esta familia que coincidan.</p> : null}
    <div className="grid max-h-[45vh] grid-cols-2 gap-2 overflow-y-auto sm:grid-cols-3">
      {familyRows.map((item) => <button type="button" key={item.id} disabled={disabled} aria-pressed={value?.id === item.id} onClick={() => onSelect(item)} className={`rounded border p-2 text-left ${value?.id === item.id ? 'border-blue-500 bg-blue-50 ring-1 ring-blue-500' : 'hover:bg-gray-50'}`}>
        {item.images?.length ? <img className="h-24 w-full object-contain" src={item.images[item.main_image_index || 0] || item.images[0]} alt={item.description} /> : <div className="flex h-24 items-center justify-center bg-gray-100 text-xs text-gray-500">Sin imagen</div>}
        <b className="mt-1 block text-sm">{item.code}</b><span className="block text-xs">{item.description}</span>
      </button>)}
    </div>
    {rows.length >= 79 && <p className="text-xs text-gray-500">Afina la búsqueda para ver más artículos.</p>}
    {value && <p className="text-sm">Seleccionado: <b>{value.code} · {value.description}</b></p>}
  </div>;
}
